import { gql, MutationFunction } from '@apollo/client';

export const UpdatePersonEmail = gql`
  mutation UpdatePersonEmail(
    $personIdentifier: String!
    $organizationCode: String!
    $newEmail: String!
  ) {
    updatePersonEmail(
      personIdentifier: $personIdentifier
      organizationCode: $organizationCode
      newEmail: $newEmail
    )
  }
`;

export type UpdatePersonEmailMutation = MutationFunction<
  {},
  UpdatePersonEmailVariables
>;
